import * as React from 'react';
import HelpIcon from '@mui/icons-material/Help';
import { TApiQuestionEntity } from '../../types/Survey';

interface IQuestionIconsProps {
  question: TApiQuestionEntity;
  setModalOpen: (value: React.SetStateAction<boolean>) => void;
}

const QuestionIcons: React.FC<IQuestionIconsProps> = ({
  question,
  setModalOpen,
}): JSX.Element | null => {
  if (!question.helpText || question.helpTextInline) {
    return null;
  }

  return (
    <HelpIcon
      onClick={() => setModalOpen(true)}
      style={{ flexShrink: 0, cursor: 'pointer' }}
    />
  );
};

export default QuestionIcons;
